export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "year_analysis": "ವರ್ಷ ವಿಶ್ಲೇಷಣೆ",
    "yearly_cosmic_insights": "ವಾರ್ಷಿಕ ಕಾಸ್ಮಿಕ್ ಒಳನೋಟಗಳು",
    "year_analysis_description": "ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ಮತ್ತು ಸಂಖ್ಯಾಶಾಸ್ತ್ರದ ಆಧಾರದ ಮೇಲೆ ಸಮಗ್ರ ವಾರ್ಷಿಕ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ. ನಿಮ್ಮ ವರ್ಷದ ವಿಷಯಗಳು, ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳು, ಶುಭ ಅವಧಿಗಳು, ಸವಾಲುಗಳು ಮತ್ತು ವರ್ಷವಿಡೀ ಯಶಸ್ಸಿಗಾಗಿ ವೈಯಕ್ತಿಕ ಮಾರ್ಗದರ್ಶನವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ.",

    "know_your": "ನಿಮ್ಮ",

    // Service Information
    "enter_details_for_year_analysis": "ವರ್ಷ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_year_analysis": "ಸಂಪೂರ್ಣ ವರ್ಷ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_year_analysis_note": "ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ಸಮಯ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ವಿಸ್ತೃತ ವಾರ್ಷಿಕ ಮುನ್ಸೂಚನೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_yearly_influence": "ನಿಮ್ಮ ಹೆಸರು ವಾರ್ಷಿಕ ಕಂಪನಗಳು ಮತ್ತು ವಾರ್ಷಿಕ ಚಕ್ರಗಳ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_yearly_cycles": "ವೈಯಕ್ತಿಕ ವರ್ಷ ಚಕ್ರಗಳು ಮತ್ತು ವಾರ್ಷಿಕ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲು ಅಗತ್ಯವಾದುದು",
    "analysis_year": "ವಿಶ್ಲೇಷಣೆ ವರ್ಷ",
    "year_2024": "2024",
    "year_2025": "2025",
    "year_2026": "2026",
    "select_year_for_analysis": "ನೀವು ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆ ಬಯಸುವ ವರ್ಷವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core Year Features
    "complete_yearly_forecast": "ಸಂಪೂರ್ಣ ವಾರ್ಷಿಕ ಮುನ್ಸೂಚನೆ",
    "monthly_breakdown_analysis": "ಮಾಸಿಕ ವಿಭಜನೆ ವಿಶ್ಲೇಷಣೆ",
    "major_life_events_timing": "ಪ್ರಮುಖ ಜೀವನ ಘಟನೆಗಳ ಸಮಯ",
    "favorable_unfavorable_periods": "ಅನುಕೂಲಕರ ಮತ್ತು ಪ್ರತಿಕೂಲ ಅವಧಿಗಳು",
    "yearly_remedies_guidance": "ವಾರ್ಷಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯು ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "comprehensive_yearly_roadmap": "ಸಮಗ್ರ ವಾರ್ಷಿಕ ಮಾರ್ಗಸೂಚಿ",
    "month_by_month_predictions": "ತಿಂಗಳ ಮತ್ತು ತಿಂಗಳ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "auspicious_timing_guide": "ಶುಭ ಸಮಯ ಮಾರ್ಗದರ್ಶಿ",
    "yearly_remedial_solutions": "ವಾರ್ಷಿಕ ಪರಿಹಾರ ಪರಿಹಾರಗಳು",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "year_analysis_processing": "ನಿಮ್ಮ ಸಮಗ್ರ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನೀವು ವಿಸ್ತೃತ ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ವಾರ್ಷಿಕ ಮಾರ್ಗದರ್ಶನವನ್ನು ಸ್ವೀಕರಿಸುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_18_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ವರ್ಷ ವಿಶ್ಲೇಷಣೆ 18 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ವರ್ಷ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_year_analysis": "ವಿಸ್ತೃತ ವರ್ಷ ವಿಶ್ಲೇಷಣೆ ವರದಿ (PDF)",
    "monthly_predictions_calendar": "ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳ ಕ್ಯಾಲೆಂಡರ್",
    "auspicious_dates_timing": "ಶುಭ ದಿನಾಂಕಗಳು ಮತ್ತು ಸಮಯ",
    "yearly_remedies_guide": "ವಾರ್ಷಿಕ ಪರಿಹಾರಗಳ ಮಾರ್ಗದರ್ಶಿ",
    "life_events_forecast": "ಜೀವನ ಘಟನೆಗಳ ಮುನ್ಸೂಚನೆ",

    // Visual Content
    "sample_year_analysis": "ಮಾದರಿ ವರ್ಷ ವಿಶ್ಲೇಷಣೆ",
    "yearly_theme": "ವಾರ್ಷಿಕ ವಿಷಯ",
    "sample_yearly_reading": "ಹಣಕಾಸಿನ ಸ್ಥಿರತೆಯ ಗಮನದೊಂದಿಗೆ ಬೆಳವಣಿಗೆ ಮತ್ತು ರೂಪಾಂತರ",
    "sample_year_preview": "ಮಾಸಿಕ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "monthly_overview": "ಮಾಸಿಕ ಅವಲೋಕನ",

    // Month Abbreviations
    "jan": "ಜನ",
    "feb": "ಫೆಬ್ರ",
    "mar": "ಮಾರ್ಚ್",
    "apr": "ಏಪ್ರಿಲ್",
    "may": "ಮೇ",
    "jun": "ಜೂನ್",
    "jul": "ಜುಲೈ",
    "aug": "ಆಗ",
    "sep": "ಸೆಪ್ಟೆ",
    "oct": "ಅಕ್ಟೋ",
    "nov": "ನವೆಂ",
    "dec": "ಡಿಸೆಂ",

    // Status & Processing
    "your_year_analysis_status": "ನಿಮ್ಮ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ವರ್ಷವನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ಸಮಯ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ನಿಮ್ಮ ಸಮಗ್ರ ವರ್ಷ ವಿಶ್ಲೇಷಣೆಯನ್ನು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_18_hours": "18 ಗಂಟೆಗಳೊಳಗೆ ವರದಿ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ವರ್ಷ ವಿಶ್ಲೇಷಣೆ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Year-Specific Elements
    "personal_year_number": "ವೈಯಕ್ತಿಕ ವರ್ಷ ಸಂಖ್ಯೆ",
    "annual_theme": "ವಾರ್ಷಿಕ ವಿಷಯ",
    "year_vibration": "ವರ್ಷದ ಕಂಪನ",
    "yearly_cycles": "ವಾರ್ಷಿಕ ಚಕ್ರಗಳು",
    "annual_lessons": "ವಾರ್ಷಿಕ ಪಾಠಗಳು",
    "year_challenges": "ವರ್ಷದ ಸವಾಲುಗಳು",

    // Monthly Analysis
    "january_analysis": "ಜನವರಿ ವಿಶ್ಲೇಷಣೆ",
    "february_analysis": "ಫೆಬ್ರವರಿ ವಿಶ್ಲೇಷಣೆ",
    "march_analysis": "ಮಾರ್ಚ್ ವಿಶ್ಲೇಷಣೆ",
    "april_analysis": "ಏಪ್ರಿಲ್ ವಿಶ್ಲೇಷಣೆ",
    "may_analysis": "ಮೇ ವಿಶ್ಲೇಷಣೆ",
    "june_analysis": "ಜೂನ್ ವಿಶ್ಲೇಷಣೆ",
    "july_analysis": "ಜುಲೈ ವಿಶ್ಲೇಷಣೆ",
    "august_analysis": "ಆಗಸ್ಟ್ ವಿಶ್ಲೇಷಣೆ",
    "september_analysis": "ಸೆಪ್ಟೆಂಬರ್ ವಿಶ್ಲೇಷಣೆ",
    "october_analysis": "ಅಕ್ಟೋಬರ್ ವಿಶ್ಲೇಷಣೆ",
    "november_analysis": "ನವೆಂಬರ್ ವಿಶ್ಲೇಷಣೆ",
    "december_analysis": "ಡಿಸೆಂಬರ್ ವಿಶ್ಲೇಷಣೆ",

    // Quarterly Analysis
    "first_quarter": "ಮೊದಲ ತ್ರೈಮಾಸಿಕ (ಜನ-ಮಾರ್ಚ್)",
    "second_quarter": "ಎರಡನೇ ತ್ರೈಮಾಸಿಕ (ಏಪ್ರಿಲ್-ಜೂನ್)",
    "third_quarter": "ಮೂರನೇ ತ್ರೈಮಾಸಿಕ (ಜುಲೈ-ಸೆಪ್ಟೆಂ)",
    "fourth_quarter": "ನಾಲ್ಕನೇ ತ್ರೈಮಾಸಿಕ (ಅಕ್ಟೋ-ಡಿಸೆಂ)",
    "quarterly_themes": "ತ್ರೈಮಾಸಿಕ ವಿಷಯಗಳು",
    "seasonal_influences": "ಋತುಮಾನದ ಪ್ರಭಾವಗಳು",

    // Life Areas Yearly Focus
    "career_year_focus": "ವೃತ್ತಿ ವರ್ಷದ ಗಮನ",
    "love_relationships_year": "ಪ್ರೀತಿ ಮತ್ತು ಸಂಬಂಧಗಳ ವರ್ಷ",
    "health_wellness_year": "ಆರೋಗ್ಯ ಮತ್ತು ಯೋಗಕ್ಷೇಮ ವರ್ಷ",
    "financial_year_outlook": "ಹಣಕಾಸಿನ ವರ್ಷದ ದೃಷ್ಟಿಕೋನ",
    "family_social_year": "ಕುಟುಂಬ ಮತ್ತು ಸಾಮಾಜಿಕ ವರ್ಷ",
    "spiritual_growth_year": "ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆಯ ವರ್ಷ",

    // Timing & Periods
    "peak_success_periods": "ಪೀಕ್ ಯಶಸ್ಸಿನ ಅವಧಿಗಳು",
    "challenging_periods": "ಸವಾಲಿನ ಅವಧಿಗಳು",
    "neutral_periods": "ತಟಸ್ಥ ಅವಧಿಗಳು",
    "transformation_phases": "ರೂಪಾಂತರ ಹಂತಗಳು",
    "opportunity_windows": "ಅವಕಾಶದ ಕಿಟಕಿಗಳು",
    "caution_periods": "ಎಚ್ಚರಿಕೆ ಅವಧಿಗಳು",

    // Auspicious Timing
    "best_months_for_new_ventures": "ಹೊಸ ಉದ್ಯಮಗಳಿಗೆ ಅತ್ಯುತ್ತಮ ತಿಂಗಳುಗಳು",
    "favorable_travel_periods": "ಅನುಕೂಲಕರ ಪ್ರಯಾಣ ಅವಧಿಗಳು",
    "auspicious_wedding_dates": "ಶುಭ ಮದುವೆ ದಿನಾಂಕಗಳು",
    "good_investment_timing": "ಉತ್ತಮ ಹೂಡಿಕೆ ಸಮಯ",
    "career_change_timing": "ವೃತ್ತಿ ಬದಲಾವಣೆ ಸಮಯ",
    "property_purchase_timing": "ಆಸ್ತಿ ಖರೀದಿ ಸಮಯ",

    // Annual Predictions
    "career_predictions": "ವೃತ್ತಿ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "business_forecast": "ವ್ಯಾಪಾರ ಮುನ್ಸೂಚನೆ",
    "financial_outlook": "ಹಣಕಾಸಿನ ದೃಷ್ಟಿಕೋನ",
    "relationship_predictions": "ಸಂಬಂಧದ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "health_forecast": "ಆರೋಗ್ಯ ಮುನ್ಸೂಚನೆ",
    "family_predictions": "ಕುಟುಂಬ ಭವಿಷ್ಯವಾಣಿಗಳು",

    // Success Factors
    "key_success_factors": "ಮುಖ್ಯ ಯಶಸ್ಸಿನ ಅಂಶಗಳು",
    "growth_opportunities": "ಬೆಳವಣಿಗೆಯ ಅವಕಾಶಗಳು",
    "skill_development_focus": "ಕೌಶಲ್ಯ ಅಭಿವೃದ್ಧಿ ಗಮನ",
    "networking_opportunities": "ನೆಟ್‌ವರ್ಕಿಂಗ್ ಅವಕಾಶಗಳು",
    "leadership_potential": "ನಾಯಕತ್ವದ ಸಾಮರ್ಥ್ಯ",
    "creative_expression": "ಸೃಜನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ",

    // Challenges & Solutions
    "potential_obstacles": "ಸಂಭಾವ್ಯ ಅಡೆತಡೆಗಳು",
    "problem_solving_guidance": "ಸಮಸ್ಯೆ ಪರಿಹಾರ ಮಾರ್ಗದರ್ಶನ",
    "stress_management": "ಒತ್ತಡ ನಿರ್ವಹಣೆ",
    "conflict_resolution": "ಸಂಘರ್ಷ ಪರಿಹಾರ",
    "decision_making_support": "ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವ ಬೆಂಬಲ",
    "risk_mitigation": "ಅಪಾಯ ತಗ್ಗಿಸುವಿಕೆ",

    // Personal Development
    "character_development": "ಪಾತ್ರ ಅಭಿವೃದ್ಧಿ",
    "habit_formation": "ಪ್ರಯೋಜನಕಾರಿ ಅಭ್ಯಾಸ ರಚನೆ",
    "goal_setting_guidance": "ಗುರಿ ನಿಗದಿ ಮಾರ್ಗದರ್ಶನ",
    "motivation_factors": "ಪ್ರೇರಣಾ ಅಂಶಗಳು",
    "confidence_building": "ಆತ್ಮವಿಶ್ವಾಸ ನಿರ್ಮಾಣ",
    "self_improvement_areas": "ಸ್ವಯಂ ಸುಧಾರಣೆ ಕ್ಷೇತ್ರಗಳು",

    // Relationship Year
    "love_life_forecast": "ಪ್ರೀತಿ ಜೀವನ ಮುನ್ಸೂಚನೆ",
    "marriage_prospects": "ವಿವಾಹದ ಭವಿಷ್ಯ",
    "family_harmony": "ಕುಟುಂಬ ಸಾಮರಸ್ಯ",
    "friendship_developments": "ಸ್ನೇಹದ ಬೆಳವಣಿಗೆಗಳು",
    "social_connections": "ಸಾಮಾಜಿಕ ಸಂಪರ್ಕಗಳು",
    "partnership_opportunities": "ಪಾಲುದಾರಿಕೆ ಅವಕಾಶಗಳು",

    // Financial Year
    "income_growth_potential": "ಆದಾಯ ಬೆಳವಣಿಗೆಯ ಸಾಮರ್ಥ್ಯ",
    "expenditure_patterns": "ಖರ್ಚಿನ ಮಾದರಿಗಳು",
    "investment_guidance": "ಹೂಡಿಕೆ ಮಾರ್ಗದರ್ಶನ",
    "debt_management": "ಸಾಲ ನಿರ್ವಹಣೆ",
    "savings_opportunities": "ಉಳಿತಾಯ ಅವಕಾಶಗಳು",
    "financial_planning": "ಹಣಕಾಸಿನ ಯೋಜನೆ",

    // Health Year
    "vitality_levels": "ಚೈತನ್ಯ ಮಟ್ಟಗಳು",
    "health_maintenance": "ಆರೋಗ್ಯ ನಿರ್ವಹಣೆ",
    "fitness_goals": "ಫಿಟ್‌ನೆಸ್ ಗುರಿಗಳು",
    "wellness_practices": "ಆರೋಗ್ಯ ಅಭ್ಯಾಸಗಳು",
    "preventive_care": "ತಡೆಗಟ್ಟುವ ಆರೈಕೆ",
    "mental_health_focus": "ಮಾನಸಿಕ ಆರೋಗ್ಯ ಗಮನ",

    // Career Year
    "professional_growth": "ವೃತ್ತಿಪರ ಬೆಳವಣಿಗೆ",
    "job_opportunities": "ಕೆಲಸದ ಅವಕಾಶಗಳು",
    "skill_enhancement": "ಕೌಶಲ್ಯ ವರ್ಧನೆ",
    "leadership_roles": "ನಾಯಕತ್ವದ ಪಾತ್ರಗಳು",
    "career_transitions": "ವೃತ್ತಿ ಪರಿವರ್ತನೆಗಳು",
    "recognition_achievements": "ಗುರುತಿಸುವಿಕೆ ಮತ್ತು ಸಾಧನೆಗಳು",

    // Spiritual Year
    "spiritual_awakening": "ಆಧ್ಯಾತ್ಮಿಕ ಜಾಗೃತಿ",
    "meditation_practices": "ಧ್ಯಾನ ಅಭ್ಯಾಸಗಳು",
    "inner_growth": "ಆಂತರಿಕ ಬೆಳವಣಿಗೆ",
    "wisdom_development": "ಬುದ್ಧಿವಂತಿಕೆ ಅಭಿವೃದ್ಧಿ",
    "divine_connections": "ದೈವಿಕ ಸಂಪರ್ಕಗಳು",
    "karmic_lessons": "ಕಾರ್ಮಿಕ ಪಾಠಗಳು",

    // Travel & Adventure
    "travel_opportunities": "ಪ್ರಯಾಣ ಅವಕಾಶಗಳು",
    "adventure_potential": "ಸಾಹಸ ಸಾಮರ್ಥ್ಯ",
    "cultural_experiences": "ಸಾಂಸ್ಕೃತಿಕ ಅನುಭವಗಳು",
    "educational_journeys": "ಶೈಕ್ಷಣಿಕ ಪ್ರಯಾಣಗಳು",
    "pilgrimage_possibilities": "ತೀರ್ಥಯಾತ್ರೆಯ ಸಾಧ್ಯತೆಗಳು",
    "foreign_connections": "ವಿದೇಶಿ ಸಂಪರ್ಕಗಳು",

    // Learning & Education
    "learning_opportunities": "ಕಲಿಕೆಯ ಅವಕಾಶಗಳು",
    "skill_certifications": "ಕೌಶಲ್ಯ ಪ್ರಮಾಣಪತ್ರಗಳು",
    "knowledge_expansion": "ಜ್ಞಾನ ವಿಸ್ತರಣೆ",
    "teaching_possibilities": "ಬೋಧನೆಯ ಸಾಧ್ಯತೆಗಳು",
    "research_projects": "ಸಂಶೋಧನಾ ಯೋಜನೆಗಳು",
    "academic_pursuits": "ಶೈಕ್ಷಣಿಕ ಅನುಸರಣೆಗಳು",

    // Creative & Artistic
    "creative_projects": "ಸೃಜನಾತ್ಮಕ ಯೋಜನೆಗಳು",
    "artistic_expression": "ಕಲಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ",
    "innovative_ideas": "ನವೀನ ಕಲ್ಪನೆಗಳು",
    "creative_collaborations": "ಸೃಜನಾತ್ಮಕ ಸಹಯೋಗಗಳು",
    "artistic_recognition": "ಕಲಾತ್ಮಕ ಗುರುತಿಸುವಿಕೆ",
    "creative_income": "ಸೃಜನಾತ್ಮಕ ಆದಾಯದ ಸಾಮರ್ಥ್ಯ",

    // Social & Community
    "community_involvement": "ಸಮುದಾಯ ಒಳಗೊಳ್ಳುವಿಕೆ",
    "social_influence": "ಸಾಮಾಜಿಕ ಪ್ರಭಾವ",
    "public_recognition": "ಸಾರ್ವಜನಿಕ ಗುರುತಿಸುವಿಕೆ",
    "group_activities": "ಗುಂಪು ಚಟುವಟಿಕೆಗಳು",
    "social_causes": "ಸಾಮಾಜಿಕ ಕಾರಣಗಳು",
    "humanitarian_work": "ಮಾನವೀಯ ಕೆಲಸ",

    // Technology & Innovation
    "technological_adaptation": "ತಾಂತ್ರಿಕ ಹೊಂದಾಣಿಕೆ",
    "digital_opportunities": "ಡಿಜಿಟಲ್ ಅವಕಾಶಗಳು",
    "innovation_potential": "ನಾವೀನ್ಯತೆಯ ಸಾಮರ್ಥ್ಯ",
    "online_presence": "ಆನ್‌ಲೈನ್ ಉಪಸ್ಥಿತಿ",
    "tech_skill_development": "ಟೆಕ್ ಕೌಶಲ್ಯ ಅಭಿವೃದ್ಧಿ",
    "digital_transformation": "ಡಿಜಿಟಲ್ ರೂಪಾಂತರ"
};
